import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Category = async () => {
  try {
    return await getData(`/without-login/allcategories`);
  } catch (error) {
    console.log(error);
  }
};

export const categoryForWebsite = async () => {
  try {
    return await getData(`/without-login/get-all-category-website`);
  } catch (error) {
    console.log(error);
  }
};

export const CategoryForSeller = async () => {
  try {
    return await getData(`/without-login/all-category-for-seller`);
  } catch (error) {
    console.log(error);
  }
};

export const SubCategory = async (id) => {
  try {
    return await getData(`/without-login/allsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const singleSubCategory = async (id) => {
  try {
    return await getData(`/without-login/subcategory/${id}`);
  } catch (error) {
    console.log(error);
  }
};
export const ChildSubCategory = async (id) => {
  try {
    return await getData(`/without-login/allchildsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const popularCategory = async () => {
  try {
    return await getData(`/without-login/all-pupular-category`);
  } catch (error) {
    console.log(error);
  }
};

export const Products = async (
  category_id = "",
  sub_category_id = "",
  child_sub_category_id = "",
  seller_id = "",
  productIds = "",
  sort_order = ""
) => {
  try {
    let url = "/without-login/product/filter";

    if (category_id && sub_category_id && child_sub_category_id && seller_id) {
      url += `?category_id=${category_id}&sub_category_id=${sub_category_id}&child_sub_category_id=${child_sub_category_id}&seller_id=${seller_id}`;
    } else if (category_id) {
      url += `?category_id=${category_id}`;
    } else if (sub_category_id) {
      url += `?sub_category_id=${sub_category_id}`;
    } else if (child_sub_category_id) {
      url += `?child_sub_category_id=${child_sub_category_id}`;
    } else if (productIds) {
      url += `?productIds=${productIds}`;
    } else if (sort_order) {
      url += `?sort_order=${sort_order}`;
    }

    if (seller_id) {
      url += `&seller_id=${seller_id}`;
    }
    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};

export const AllProductsData = async (
  category_id = "",
  sort_order = "",
  searchTerm = "",
  sizeSearach = ""
) => {
  try {

    let url = "/without-login/product/filter";

    if (category_id || sort_order || sizeSearach) {
      url += `?category_id=${category_id}&sort_price=${sort_order}&term=${searchTerm}&size=${sizeSearach}`;
    } else if (category_id) {
      url += `?category_id=${category_id}`;
    } else if (sort_order) {
      url += `?sort_price=${sort_order}`;
    } else if (sizeSearach) {

      url += `?size=${sizeSearach}`;
    } else if (searchTerm) {
      url += `?term=${searchTerm}`;
    }

    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};

export const ProductsSale = async (
  category_id = "",
  sub_category_id = "",
  child_sub_category_id = "",
  seller_id = "",
  productIds = "",
  sort_order = "",
  sizeSearach = ""
) => {
  try {
    let url = "/without-login/product/sale/filter";

    if (category_id || sort_order || sizeSearach) {
      url += `?category_id=${category_id}&sort_order=${sort_order}&size=${sizeSearach}`;
    } else if (
      category_id &&
      sub_category_id &&
      child_sub_category_id &&
      seller_id
    ) {
      url += `?category_id=${category_id}&sub_category_id=${sub_category_id}&child_sub_category_id=${child_sub_category_id}&seller_id=${seller_id}`;
    } else if (category_id) {
      url += `?category_id=${category_id}`;
    } else if (sub_category_id) {
      url += `?sub_category_id=${sub_category_id}`;
    } else if (child_sub_category_id) {
      url += `?child_sub_category_id=${child_sub_category_id}`;
    } else if (productIds) {
      url += `?productIds=${productIds}`;
    } else if (sort_order) {
      url += `?sort_order=${sort_order}`;
    }

    if (seller_id) {
      url += `&seller_id=${seller_id}`;
    }
    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};

export const ProductsRecentView = async (
  category_id = "",
  sub_category_id = "",
  child_sub_category_id = "",
  seller_id = "",
  productIds = ""
) => {
  try {
    let url = "/without-login/product/recent-view";

    if (category_id && sub_category_id && child_sub_category_id && seller_id) {
      url += `?category_id=${category_id}&sub_category_id=${sub_category_id}&child_sub_category_id=${child_sub_category_id}&seller_id=${seller_id}`;
    } else if (category_id) {
      url += `?category_id=${category_id}`;
    } else if (sub_category_id) {
      url += `?sub_category_id=${sub_category_id}`;
    } else if (child_sub_category_id) {
      url += `?child_sub_category_id=${child_sub_category_id}`;
    } else if (productIds) {
      url += `?productIds=${productIds}`;
    }

    if (seller_id) {
      url += `&seller_id=${seller_id}`;
    }
    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};

export const getProductDetail = async (id) => {
  try {
    return await getData(`/without-login/product/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getProductVariant = async (id) => {
  try {
    return await getData(`/without-login/product/variants/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getProductSubVariant = async (id) => {
  try {
    return await getData(`/without-login/product/sub-variants/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getVariant = async (id) => {
  try {
    return await getData(`/without-login/product/variant/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getMultiVariant = async (id) => {
  try {
    return await getData(`/without-login/product/multi-variant/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const allProductReviewGet = async (id) => {
  try {
    return await getData(`/without-login/home/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewGet = async (id) => {
  try {
    return await getData(`/review/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewPost = async (data) => {
  try {
    return await postData(`/review/add`, data);
  } catch (error) {
    console.log(error);
  }
};

export const productList = async () => {
  try {
    return await getData(`/without-login/product`);
  } catch (error) {
    console.log(error);
  }
};
